module.exports = __webpack_public_path__ + "static/media/YL_gauge_bg.ddd523be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YL_gauge_bg.png
// module id = 1208
// module chunks = 0